export const VEHICLE_FIELDS = {
    FUEL_TYPE: 'Fuel Type',
    OWNER_NAME: 'Owner Name',
    MODEL_NAME: 'Model | Variant'
}
